import { ApiHandler } from '@eshop/api-client'

import type { Engine } from '#/App'

import { Config } from '#/global/helper/Config'

export const fetchItemsCount = async (query: string) => {
    const api = new ApiHandler({
        apiEndpoint: 'search',
        path: '/v2/{company}/search-counts',
        pathParameters: {
            company: Config.getSearchCompany(),
        },
        parameters: {
            query,
        },
    })

    // Pokud je response 303, tak se vrátí redirect_url
    // api.getData(true) vrátí data i při statusu !== 200 (response.ok === false)
    api.addResponseHandler(303, async () => {
        return api.getData(true)
    })

    return await api.send<{ engine_name: Engine, total_count: number }[] | { redirect_url: string }>() ?? []
}
